import {RegisteredCountry} from "../models/RegisteredCountry";

const Countries: RegisteredCountry[] = [
    new RegisteredCountry("GB", "United Kingdom"), 
    new RegisteredCountry("US", "United States")]

export {Countries};
